import {DAYS_MODEL, DEFAULT_LATITUDE, DEFAULT_LONGITUDE} from "../../../../../Apis/functions";

export const CAFETERIA_MODEL = {
    id: null,
    name: '',
    description: '',
    code: '',
    capacity: '',
    latitude: null,
    longitude: null,
    openTime: null,
    closeTime:null,
    schedule:{
        sunday:false,
        monday:false,
        tuesday:false,
        wednesday:false,
        thursday:false,
        friday:false,
        saturday:false
    },
    statusId: null,
    deviceIds:[],
    isValidSetUpData: function () {
        return this.name !== '' && this.code !== '' && this.capacity !== '' && this.statusId !== null;
    },
   isValidAccessData: function (dayArray) {
    const isValid = this.openTime !== null 
        && this.closeTime !== null 
        && this.closeTime >= this.openTime 
        && dayArray?.length > 0;
    return isValid;
},
    isValidCapacity: function () {
        return parseInt(this.capacity) > 0;
    },
    toRegister: function () {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            code: this.code,
            capacity: this.capacity,
            latitude: this.latitude,
            longitude: this.longitude,
            schedule:{...this.schedule, openTime:this.openTime, closeTime:this.closeTime},
            statusId:this.statusId,
            deviceIds: this.deviceIds,

        }
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            name: data.name,
            description: data.description,
            code: data.code,
            capacity: data.capacity,
            latitude: data.latitude,
            longitude: data.longitude,
            openTime: data.schedule.openTime,
            closeTime: data.schedule.closeTime,
            schedule: {...this.schedule, ...data.schedule},
            statusId:data.statusId,
            deviceIds: data.devices?.map(e => e.id) || []

        }
    },
}

export const getSelected = (row) => {
    let aux = [];
    Object.entries(row?.schedule).map(saved => {
        DAYS_MODEL.map(day =>{
            if(day?.key === saved[0] && saved[1] === true) aux.push(day?.value);
        })
    });
    return aux;
}

